import { Link } from "react-router-dom";

export const Logo = ({ size = "text-2xl" }) => (
  <Link to="/" data-testid="logo-link" className={`font-display font-black tracking-tight ${size} flex items-center gap-2 wiggle`}>
    <img src="/logo-cherry.png" alt="easysweetchat meggy logó" className="h-12 w-12 shrink-0 drop-shadow-[0_0_14px_rgba(255,59,108,0.55)]" />
    <span>
      easy<span className="text-[#FF3B6C]">sweet</span><span className="text-[#00F0FF]">chat</span><span className="text-[#FFD600]">.com</span>
    </span>
  </Link>
);
